import AdminWebHttpService from "@/services/http/AdminWebHttpService";

export function updateChatId(chat_id) {
  return AdminWebHttpService.post("updateChatId", { chat_id });
}
